import React from 'react'

import * as Styles from './styles'

export default function NoTeacher() {
    // TODO: Add teacher name eg. Rajesh Sir
    const teacherName = 'Teacher'
    const text = `${teacherName} is joining soon`

    return (
        <Styles.Wrapper>
            <Styles.Overlay>{text}</Styles.Overlay>
        </Styles.Wrapper>
    )
}
